import { Grid, VStack } from "styled-system/jsx";
import {
  GRIDS,
  LAYOUT_HEIGHTS,
} from "@/components/organisms/GameBoard/constants";
import { GameStateActions } from "@/components/organisms/GameBoard";
import { actDrawAtlas, actDrawDeck, actShuffleDeck } from "@/utils/actions";
import { cva } from "styled-system/css/cva.mjs";
import { Modal } from "@/components/atoms/Modal";
import { useState } from "react";
import { DeckModalBody } from "./DeckPreviewModal";
import toast from "react-hot-toast";

export const DecksTray = (props: GameStateActions) => {
  const [preview, setPreview] = useState<"deck" | "atlas">();

  function draw(deck: GRIDS.DECK | GRIDS.ATLAS_DECK) {
    deck === GRIDS.DECK
      ? props.setGridItems(actDrawDeck(props.gridItems))
      : props.setGridItems(actDrawAtlas(props.gridItems));
  }

  function drawDeck() {
    draw(GRIDS.DECK);
  }
  function drawAtlas() {
    draw(GRIDS.ATLAS_DECK);
  }

  function shuffleDeck(deckType: typeof preview) {
    if (deckType) props.setGridItems(actShuffleDeck(props.gridItems, deckType));
    toast.success("Shuffled after closing");
  }

  const atlasRemainingCards = props.gridItems[GRIDS.ATLAS_DECK]?.length;
  const deckRemainingCards = props.gridItems[GRIDS.DECK]?.length;

  return (
    <>
      <Modal
        wrapperProps={{
          open: !!preview,
          onOpenChange: () => {
            // when closing the modal, delay shuffling the deck briefly
            // avoids briefly showing new deck order before modal closes
            const wasOpen = preview;
            setPreview(undefined);
            setTimeout(() => {
              if (!!wasOpen) shuffleDeck(wasOpen);
            }, 100);
          },
        }}
        content={<DeckModalBody deckType={preview} {...props} />}
      />
      <VStack
        w="100%"
        py="0.25rem"
        style={{
          height: LAYOUT_HEIGHTS.footer,
          background:
            "linear-gradient(90deg, rgba(130, 63, 28, 0.82) 0%, rgba(99, 29, 5, 0.59) 50%, rgba(69, 50, 23, 0.75) 100%)",
          // background:
          //   "linear-gradient(90deg, rgba(131,58,180,0.15) 0%, rgba(253,29,29,0.15) 50%, rgba(252,176,69,0.35) 100%)",
        }}
      >
        <Grid
          onContextMenu={(e) => {
            e.preventDefault();
            setPreview("atlas");
          }}
          h="65px"
          aspectRatio={411 /300}
          onClick={drawAtlas}
          placeItems="center"
          borderRadius="0.25rem"
          cursor="pointer"
          backgroundSize="cover"
          style={{
            backgroundImage: "url(/card-backs/m_atlas.png)",
          }}
        >
          <p className={remainingCards()}>{atlasRemainingCards}</p>
        </Grid>
        <Grid
          onContextMenu={(e) => {
            e.preventDefault();
            setPreview("deck");
          }}
          w="65px"
          aspectRatio={300 / 411}
          onClick={drawDeck}
          placeItems="center"
          borderRadius="0.25rem"
          cursor="pointer"
          backgroundSize="cover"
          style={{
            backgroundImage: "url(/card-backs/m_spells.png)",
          }}
        >
          <p className={remainingCards()}>{deckRemainingCards}</p>
        </Grid>
      </VStack>
    </>
  );
};

const remainingCards = cva({
  base: {
    fontWeight: 700,
    background: "rgba(255,255,255,0.7)",
    padding: "0 0.25rem",
    borderRadius: "0.25rem",
  },
});
